import React, { useState } from "react";
import { EmailLogo, LockIcon } from "../../assets/svg";
import FormBox from "./formBox";
import { useDispatch } from "react-redux";
import { setCredentials, updateImage } from "../../authSlice";
import toast from "react-hot-toast";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtpLogin, setShowOtpLogin] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isBlocked, setIsBlocked] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleSendMail = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/sendMail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.status === 200) {
          toast.success(data.message, {
            style: {
              border: "1px solid #021F7E",
              padding: "16px",
              color: "#0573E3",
            },
            iconTheme: {
              primary: "#021F7E",
              secondary: "#fff",
            },
            duration: 6000,
          });
          setShowOtpLogin(true);
        }
      } else {
        const data = await response.json();
        toast.error(data.message, {
          style: {
            border: "1px solid #FE0000",
            padding: "16px",
            color: "#FE0000",
          },
          iconTheme: {
            primary: "#FE0000",
            secondary: "#FE000099",
          },
          duration: 6000,
        });
        console.error("failed to send mail:", data);
      }
    } catch (error) {
      console.error("Error sending mail:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async () => {
    setError("");
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        toast.success("Logged in Successfully.", {
          style: {
            border: "1px solid #021F7E",
            padding: "16px",
            color: "#0573E3",
          },
          iconTheme: {
            primary: "#021F7E",
            secondary: "#0573E3",
          },
        });
        dispatch(
          setCredentials({ token: data.token, username: data.user.name })
        );
        dispatch(updateImage(data.user.image));
      } else {
        const data = await response.json();
        setError(data.message);
        console.error("Login failed:", data);
        if (data.isBlocked) {
          setIsBlocked(true);
          handleSendMail();
        }
      }
    } catch (error) {
      console.error("Error logging in:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLoginWithOtp = async () => {
    setError("");
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/verifyOtpLogin`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, otp }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        toast.success("Logged in Successfully.", {
          style: {
            border: "1px solid #021F7E",
            padding: "16px",
            color: "#0573E3",
          },
          iconTheme: {
            primary: "#021F7E",
            secondary: "#0573E3",
          },
        });
        dispatch(
          setCredentials({ token: data.token, username: data.user.name })
        );
        setIsBlocked(false);
      } else {
        const data = await response.json();
        toast.error(data.message, {
          style: {
            border: "1px solid #FE0000",
            padding: "16px",
            color: "#FE0000",
          },
          iconTheme: {
            primary: "#FE0000",
            secondary: "#FE000099",
          },
          duration: 6000,
        });
        console.error("Login failed:", data);
        if (data.isBlocked) {
          setIsBlocked(true);
          handleSendMail();
        }
      }
    } catch (error) {
      console.error("Error logging in:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <FormBox>
        <h2 className="colorHeading">Fresh Fruit Agency!</h2>
        <h4>Admin System</h4>
        <div className="customLogin">
          <EmailLogo />
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div
          className={`customLogin ${isBlocked && "disabled"}`}
          style={{ marginTop: "11px" }}
        >
          <LockIcon />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={isBlocked}
          />
        </div>
        {showOtpLogin && (
          <div className="customLogin" style={{ marginTop: "11px" }}>
            <input
              type="text"
              placeholder="Enter 6-digit code to login"
              maxLength="6"
              value={otp}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) setOtp(value);
              }}
            />
          </div>
        )}
        {error && <span className="errorClass">{error}</span>}
        {showOtpLogin ? (
          <div className="linkBox">
            {loading ? (
              <p>Sending ...</p>
            ) : (
              <p onClick={handleSendMail}>Resend OTP</p>
            )}
          </div>
        ) : (
          <div className="linkBox">
            <a href="/forgot-password">Forgot Password?</a>
          </div>
        )}
        {loading ? (
          <button className="colorBtn submitBtn">Signing In ...</button>
        ) : (
          <button
            className="colorBtn submitBtn"
            onClick={!showOtpLogin ? handleLogin : handleLoginWithOtp}
          >
            Sign In
          </button>
        )}
      </FormBox>
    </>
  );
}

export default LoginPage;
